import { render } from "./app-capability-card.vue?vue&type=template&id=17d51db2&scoped=true"
import script from "./app-capability-card.vue?vue&type=script&lang=js"
export * from "./app-capability-card.vue?vue&type=script&lang=js"

import "./app-capability-card.vue?vue&type=style&index=0&id=17d51db2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d51db2"]])

export default __exports__